import { Button } from '@dnb/eufemia';
import { bookmark } from '@dnb/eufemia/icons';
import classNames from 'classnames';

import style from './index.module.css';

interface RecentlyVisitedButtonProps {
  isActive: boolean;
  setShowRecentlyVisited: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function RecentlyVisitedButton({ isActive, setShowRecentlyVisited }: RecentlyVisitedButtonProps) {
  return (
    <Button
      className={classNames(style['RecentlyVisitedButton'], {
        [style['active']!]: isActive,
      })}
      icon={bookmark}
      icon_position="top"
      on_click={() => setShowRecentlyVisited((prev) => !prev)}
      size="large"
      title="Pinned & Recently Visited Pages"
      variant="tertiary"
    />
  );
}
